import React, { useState } from "react";
import "./CertificationCheck.css";

const CertificationCheck = () => {

  const [certId, setCertId] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {

    const cleanId = certId.trim().toUpperCase();

    if (!cleanId) {
      setError("Please enter Certification ID");
      setResult(null);
      return;
    }

    setLoading(true);
    setError("");
    setResult(null);

    try {

      const res = await fetch(`https://www.talenttrektechnologies.com/certificate-backend/api/certificate.php?id=${cleanId}`);
      
      if (!res.ok) {
        throw new Error("Invalid Certificate ID");
      }

      const data = await res.json();

      console.log("API DATA:", data);

      if (data.is_active == 0) {
  setError("Certificate not found");
  setResult(null);
} else {
  setResult(data);
}

    } catch (err) {
      console.log(err);
      setError("Invalid Certificate ID. Please check and try again.");
    }

    setLoading(false);
  };

 const isCompleted = result?.status?.toLowerCase() === "completed";

  // 🔥 Remarks formatting + class
  const getRemarksClass = (remarks) => {
    const r = remarks?.toLowerCase();
    if (r === "excellent") return "remarks-excellent";
    if (r === "good") return "remarks-good";
    return "remarks-satisfactory";
  };

  const formatRemarks = (remarks) => {
    if (!remarks) return "Satisfactory";
    return remarks.charAt(0).toUpperCase() + remarks.slice(1); 
  };

  return (
    <section className="cert-pro-section">

      <div className="cert-pro-container">

        <h1 className="cert-pro-title">Certificate Verification</h1>

        {/* 🔍 SEARCH */}
        <div className="cert-pro-search">

          <input
            type="text"
            placeholder="Enter Certification ID"
            value={certId}
            onChange={(e) => setCertId(e.target.value.toUpperCase())}
            onKeyDown={(e) => e.key === "Enter" && handleSearch()}
          />

          <button onClick={handleSearch} disabled={loading}>
            {loading ? "Checking..." : "Verify"}
          </button>

        </div>

        {/* ❌ ERROR */}
        {error && <p className="cert-pro-error">{error}</p>}

        {/* ⏳ LOADER */}
        {loading && <div className="cert-loader"></div>}

        {/* ✅ RESULT */}
        {result && !loading && (

          <div className="cert-pro-card">

            {/* STATUS BADGE */}
            <div className={`cert-badge ${isCompleted ? "verified" : "pending"}`}>
              {isCompleted ? "✓ VERIFIED" : "⌛ PENDING"}
            </div>

            <h3>Certificate Details</h3>

            <div className="cert-grid">

              {/* ROW 1 */}
              <div className="cert-row">

                <div className="cert-item">
                  <span>Name</span>
                  <strong>{result.name || "-"}</strong>
                </div>

                <div className="cert-item">
                  <span>Duration</span>
                  <strong>
  {result.duration || result.year || "-"}
</strong>
                </div>

              </div>

              {/* ROW 2 */}
              <div className="cert-row">

                <div className="cert-item">
                  <span>Program</span>
                  <strong>{result.program || "-"}</strong>
                </div>

                <div className="cert-item">
                  <span>Status</span>
                  <strong className={isCompleted ? "status-valid" : "status-pending"}>
                    {result.status || "-"}
                  </strong>
                </div>

              </div>  

              {/* ROW 3 */}
              <div className="cert-row">

                <div className="cert-item">
                  <span>Remarks</span>
                  <strong className={getRemarksClass(result.remarks)}>
                    {formatRemarks(result.remarks)}
                  </strong>
                </div>

                <div className="cert-item">
                  <span>Certificate ID</span> 
                  <strong>{result.id || "-"}</strong>
                </div>

              </div>

            </div>

          </div>

        )}

      </div>

    </section>
  );
};

export default CertificationCheck;